<template>
    <ion-header class="relative">
        <ion-toolbar>
            <ion-buttons v-if="showMenu" slot="start">
                <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-buttons v-else-if="showBack!" slot="start">
                <ion-back-button defaultHref="/costumers" @click="onBackHandler($event)"></ion-back-button>
            </ion-buttons>
            <ion-title>{{ title }}</ion-title>
            <div class="flex" slot="end">
                <ion-buttons v-if="buttons!.length > 0" style="padding-right: 12px" slot="end">
                    <template v-for="button in buttons!">
                        <ion-button @click="performAction(button)" :disabled="isButtonDisabled(button)">
                            <template
                                v-if="
                                    loaders[getButtonLoaderIndex(button.id)]
                                        ? !loaders[getButtonLoaderIndex(button.id)].loading
                                        : true
                                ">
                                <span v-if="button.label">{{ button.label }}&nbsp;&nbsp;</span>
                                <ion-icon v-if="button.icon" :icon="button.icon"></ion-icon>
                            </template>
                            <ion-spinner v-else></ion-spinner>
                        </ion-button>
                    </template>
                </ion-buttons>
                <ion-text
                    :color="isOnline ? 'success' : 'danger'"
                    style="position: absolute; top: -6px; right: 6px; font-weight: bold; font-size: 28px">
                    •
                </ion-text>
            </div>
        </ion-toolbar>
    </ion-header>
</template>

<script setup lang="ts">
import {
    IonIcon,
    IonBackButton,
    IonText,
    IonButtons,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButton,
    IonSpinner,
    IonMenuButton,
} from "@ionic/vue";
import { computed, onMounted, PropType, reactive, watch } from "vue";
import { HeaderButton, HeaderButtonLoaders } from "@/types/headerButton";
import { checkFunctionAsync } from "@/utility";
import { useNetworkStore } from "@/stores/network";
import { useRouter } from "vue-router";

const props = defineProps({
    title: {
        type: String,
        required: false,
    },
    showBack: {
        type: Boolean,
        required: false,
        default: true,
    },
    showMenu: {
        type: Boolean,
        required: false,
        default: false,
    },
    onBack: {
        type: Function as PropType<() => void>,
        required: false,
    },
    buttons: {
        type: Array as PropType<HeaderButton[]>,
        required: false,
        default: [],
    },
});
const router = useRouter();
const networkStore = useNetworkStore();
const isOnline = computed(() => networkStore.isOnline);
const loaders = reactive<HeaderButtonLoaders[]>([]);
watch(
    () => props.buttons,
    () =>
        props.buttons?.forEach((button, index) => {
            loaders.length = 0;
            if (checkFunctionAsync(button.action)) {
                loaders.push({ id: button.id, loading: false });
            }
        }),
    { immediate: true }
);

const onBackHandler = (event: any) => {
    if (props.onBack) {
        props.onBack();
    }
    router.back();
};

const isButtonDisabled = (button: HeaderButton) => {
    if (button.disabled !== undefined) {
        return button.disabled;
    }
    return loaders[getButtonLoaderIndex(button.id)] ? loaders[getButtonLoaderIndex(button.id)].loading : false;
};

const getButtonLoaderIndex = (id: number) => {
    return loaders.findIndex((loader) => loader.id === id);
};
const performAction = (button: HeaderButton) => {
    if (checkFunctionAsync(button.action)) {
        const index = getButtonLoaderIndex(button.id);
        if (!loaders[index].loading) {
            loaders[index].loading = true;
            (button.action as () => Promise<void>)().then(() => {
                loaders[index].loading = false;
            });
        }
    } else {
        button.action();
    }
};
</script>

<style scoped></style>
